import { render, staticRenderFns } from "./shipinjianjizhong_1.vue?vue&type=template&id=9c1d3718&scoped=true"
import script from "./shipinjianjizhong_1.vue?vue&type=script&lang=js"
export * from "./shipinjianjizhong_1.vue?vue&type=script&lang=js"
import style0 from "./shipinjianjizhong_1.vue?vue&type=style&index=0&id=9c1d3718&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1d3718",
  null
  
)

export default component.exports